import * as React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import Loading from "../../components/Loading";
import { Wrap } from "../../components/Layout/Page";
import NotFound from "../../containers/NotFound/NotFound";
import { loadAction } from "../../redux/modules/action/actionCreators";
import { ViewAction } from "../../components/Action/ViewAction";

interface StateProps {
  action: Insite.API.Action;
  comments: any[]; // @TODO
  userAccess: Insite.API.User["access"];
  isCommentsLoading: boolean;
  appSetupComplete: boolean;
  isLoading: boolean;
  token: string;
  urlHistory: Insite.AppState["urlHistory"];
}

interface DispatchProps {
  requestAction: typeof loadAction;
}

function mapStateToProps({
  betaAction,
  appSetup,
  auth,
  urlHistory,
}: Insite.AppState): StateProps {
  return {
    action: betaAction.action,
    comments: betaAction.comments,
    userAccess: betaAction.userAccess,
    isCommentsLoading: betaAction.isCommentsLoading,
    appSetupComplete: appSetup.appSetupComplete,
    isLoading: betaAction.isLoading,
    token: auth.user.token!, // NOTE: This null assertion shouldn't be necessary
    urlHistory,
  };
}

const mapDispatchToProps: DispatchProps = {
  requestAction: loadAction,
};

type Props = StateProps &
  DispatchProps &
  RouteComponentProps<{ actionId: string }>;
class ViewActionScene extends React.Component<Props> {
  static defaultProps = {
    action: undefined,
  };

  componentDidMount() {
    if (this.props.appSetupComplete) {
      const { match } = this.props;
      this.props.requestAction(match.params.actionId);
    }
  }

  componentDidUpdate() {
    const { appSetupComplete, isLoading, action, match } = this.props;
    if (appSetupComplete && !isLoading && action === undefined) {
      this.props.requestAction(match.params.actionId);
    }
  }

  render() {
    const {
      action,
      comments,
      userAccess,
      isCommentsLoading,
      appSetupComplete,
      isLoading,
      urlHistory,
    } = this.props;

    if (!appSetupComplete || isLoading) {
      return (
        <Wrap>
          <Loading />
        </Wrap>
      );
    }

    if (!isLoading && action === undefined) {
      return (
        <Wrap>
          <NotFound />
        </Wrap>
      );
    }

    return (
      <Wrap>
        <Helmet title="View Action" />
        <ViewAction
          action={action}
          equips={action.associatedEquips}
          comments={comments}
          userAccess={userAccess} 
          isCommentsLoading={isCommentsLoading}
          urlHistory={urlHistory}
        />
      </Wrap>
    );
  }
}

const hotConnected = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewActionScene);
export { hotConnected as ViewActionScene };
